import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

// Reusable service card with clipped frame + hover blue overlay + red arrow.
export default function ServiceCard({ service, base = "/services", testid }) {
    return (
        <Link
            to={`${base}/${service.slug}`}
            data-testid={testid || `service-card-${service.slug}`}
            className="group relative block overflow-hidden rounded-[24px] rounded-tr-[52px] bg-white shadow-brand transition-all duration-500 hover:-translate-y-2 hover:shadow-brand-lg"
        >
            <div className="relative aspect-[4/3] overflow-hidden">
                <img
                    src={service.image}
                    alt={`ProCare.SG ${service.name} service in Singapore`}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-brand-blue/0 transition-colors duration-500 group-hover:bg-brand-blue/60" />
                <span className="absolute right-4 top-4 flex h-11 w-11 translate-y-2 items-center justify-center rounded-full bg-brand-red text-white opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100">
                    <ArrowUpRight className="h-5 w-5" />
                </span>
            </div>
            <div className="p-6">
                <h3 className="font-display text-2xl font-semibold text-brand-blue">
                    {service.name}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-brand-ink/60">
                    {service.short}
                </p>
                <span className="mt-4 inline-flex items-center gap-1 text-xs font-bold uppercase tracking-[0.2em] text-brand-red">
                    Learn More <ArrowUpRight className="h-3.5 w-3.5" />
                </span>
            </div>
        </Link>
    );
}
